<h3 class="text-center">Receipt</h3>
<img [src]="link" class="img-fluid">
